<script>
import options from './LegalText.options'
export default options
</script>

<template>
    <Modal 
      :open="isOpen" 
      @close="close"
      :title="title"
      size="small-large"
      theme="white"
    >
      <template #body>
        <div v-html="body"></div>
      </template>
    </Modal>
</template>
